import {Component} from '@angular/core';
import {FormBaseComponent} from '@utils-lib';
import {OrgangesellschaftAufstellung} from '@nachdigal';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-organtraeger',
  templateUrl: './organtraeger.component.html'
})
export class OrgantraegerComponent extends FormBaseComponent<OrgangesellschaftAufstellung> {


  constructor(private readonly formBuilder: FormBuilder,
              protected readonly messageService: DatevMessageService,
              protected readonly activatedRoute: ActivatedRoute) {
    super(messageService);
  }

  protected createForm(): void {
    this.form = this.formBuilder.group({
      isGesellschaftOrgantraeger: [this.data.isGesellschaftOrgantraeger, []],
      isOrgantraegerschaftKStUndGewSt: [this.data.isOrgantraegerschaftKStUndGewSt, []],
      isOrgantraegerschaftUmsatzsteuerlich: [this.data.isOrgantraegerschaftUmsatzsteuerlich, []]
    });
  }
}
